export default __webpack_public_path__ + "static/media/fi-sr-shop.b283915e.svg";